import { IconSvg, IconSvgProps } from "./icon"

export default function Share(props: IconSvgProps) {
  return (
    <IconSvg {...props}>
      <path d="M16.5 9.429h1.286a.643.643 0 0 1 .643.642v9.643a.643.643 0 0 1-.643.643H6.214a.643.643 0 0 1-.642-.643v-9.643a.643.643 0 0 1 .642-.642H7.5m4.5 3.214v-9m0 0L9.43 6.214M12 3.643l2.572 2.571" />
    </IconSvg>
  )
}
